import BlogSearchInput from '../BlogSearchInput'
import MostReadSection from '../MostReadSection'
import SubscribeForm from '../SubscribeForm'
import TagsFilter from '../TagsFilter'
import { IBlogInterface } from './types'

const BlogSidebar = ({
  mostRead,
  filters,
  tagIds,
  setTagIds,
  searchTerm,
  setSearchTerm,
}: IBlogInterface) => {
  if (!mostRead && !filters) {
    return null
  }

  return (
    <>
      <BlogSearchInput setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
      {mostRead && <MostReadSection posts={mostRead} />}
      <SubscribeForm />
      {filters && <TagsFilter activeTags={tagIds} setTagIds={setTagIds} tags={filters} />}
    </>
  )
}

export default BlogSidebar
